export const parseAddressName = (name) => {
    if (!name) return {};

    const [streetPart, city, postalCode] = name.split(",").map((s) => s.trim());

    if (!streetPart || !city || !postalCode) return {};

    const [streetNumber, ...streetParts] = streetPart.split(" ");
    const street = streetParts.join(" ");

    return {
        streetNumber,
        street,
        city,
        postalCode,
    };
};
